import { makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(() => ({
  // Figma frame 220: 34px chips with 10px corners, a 12px color square, and 10px between square, label and count.
  root: {
    boxSizing: 'border-box',
    height: 34,
    marginRight: 10,
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
    padding: '0 12px',
    cursor: 'pointer',
    fontFamily: 'Dazzed',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '24px',
    '&:disabled': {
      cursor: 'default'
    }
  },
  square: {
    flexShrink: 0,
    width: 12,
    height: 12,
    borderRadius: 2
  },
  countField: {
    fontWeight: 600
  }
}))

const TxTrackingCategoryChip = ({ label, count, color, selected = false, disabled = false, onClick }) => {
  const classes = useStyles()

  return (
    <button
      type="button"
      className={classes.root}
      disabled={disabled}
      aria-pressed={selected}
      style={{
        opacity: disabled ? 0.4 : 1,
        backgroundColor: selected ? '#7E8DF3' : disabled ? '#F6F6F6' : '#E7EAFF',
        color: selected ? '#FFFFFF' : '#001335',
        border: selected ? '2px solid #3C52EF' : '2px solid transparent'
      }}
      onClick={onClick}
    >
      {color && <span className={classes.square} style={{ backgroundColor: color }} />}
      <span>{label}</span>
      {count !== undefined && <span className={classes.countField}>{count}</span>}
    </button>
  )
}

export default TxTrackingCategoryChip
